import { useState, React } from "react";
import FormInput from "./FormInput";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { TbWorld } from "react-icons/tb";
import { MdOutlineEmail } from "react-icons/md";
import RegisterButton from "./buttons/RegisterButton";
import axios from "axios";
import { toast } from "react-hot-toast";
import { NavLink } from "react-router-dom";

export default function ContactSection() {
  const [contactFormData, setContactFormData] = useState({
    username: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  function handleChange(e) {
    const { name, value } = e.currentTarget;

    setContactFormData((prevContactFormState) => ({
      ...prevContactFormState,
      [name]: value,
    }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (
      !contactFormData.username ||
      !contactFormData.email ||
      !contactFormData.phone ||
      !contactFormData.subject ||
      !contactFormData.message
    ) {
      return toast.error("All fields are required");
    }
    axios
      .post("/contact", {
        username: contactFormData.username,
        email: contactFormData.email,
        phone: contactFormData.phone,
        subject: contactFormData.subject,
        message: contactFormData.message,
      })
      .then(({ data }) => {
        if (data.error) {
          return toast.error(data.error);
        }
        return toast.success("contact send successfully");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setContactFormData({
          username: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      });
  }

  return (
    <section className="contact_section">
      <h2 style={{
        marginBottom: '1rem'
      }}>Get in Touch</h2>
      <p style={{
        maxWidth: "600px",
        margin: "0 auto",
        textAlign: "center",
        padding: "0 1rem",
         marginBottom: '2.55rem'
      }}>Asakaaplay is the most advanced sports prediction platform and highest stakes across multiple bookmakers and exchanges.</p>
      <div className="contact_container">
        <form className="contact_form" onSubmit={handleSubmit}>
          <FormInput
            label="Full NAME"
            type="text"
            id="username"
            placeHolder="Ex. John Doe"
            onChange={handleChange}
            value={contactFormData.username}
          />
          <FormInput
            label="Email"
            type="text"
            id="email"
            placeHolder="Ex. johndoe@gmail.com"
            onChange={handleChange}
            value={contactFormData.email}
          />
          <FormInput
            label="Phone"
            type="text"
            id="phone"
            placeHolder="233xxxxxxxxxx"
            onChange={handleChange}
            value={contactFormData.phone}
          />
          <FormInput
            label="Subject"
            type="text"
            id="subject"
            placeHolder="Ex. Service"
            onChange={handleChange}
            value={contactFormData.subject}
          />
          <div className="form_input_container textarea">
            <label htmlFor="message">Message</label>
            <textarea
              name="message"
              id="message"
              placeholder="Ex. Hello. Admin how do I ...."
              onChange={handleChange}
              value={contactFormData.message}
            ></textarea>
          </div>

          <RegisterButton
            className={"btn submit"}
            value={"Submit"}
            onSubmit={handleSubmit}
          />
        </form>

        <div className="contact_detail">
          <h1 className="logo">
            <NavLink to="/" className="main_logo">
              <img src="/logo.png" alt="logo" className="logo_image" style={{
                width: "5rem",
                height: "5rem",
              }} />
              {/* <h2>PayoutProphet</h2> */}
              {/* <div className="logo_text">
                <span>Asakaa</span>
                <span>Play</span>
              </div> */}
            </NavLink>
          </h1>

          <p>
            Asakaa Play delivers data‑driven sports predictions and fast,
            friendly support. For questions about subscriptions, tips, or
            technical help, contact our team — we typically reply within one
            business day. Our picks are for information and entertainment only;
            please gamble responsibly.
          </p>
          <article className="info">
            <p>
              <FaLocationDot /> <span>Accra, Ghana</span>
            </p>
            <p>
              <FaPhoneAlt /> <a href="tel:233500200513">233 500 20 0513</a>
            </p>
            <p>
              <MdOutlineEmail />{" "}
              <a href="mailto:asakaafixed@gmail.com">asakaafixed@gmail.com</a>
            </p>
            <p>
              <TbWorld /> <a href="home">asakaaplay.com</a>
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
